import './pwa.css';
import type { ReactNode } from 'react';
import { InstallContext } from './install-context';
import { useInstallPrompt } from '@/lib/useInstallPrompt';
export function PwaProvider({ children }: { children: ReactNode }) {
  const install = useInstallPrompt();
  return <InstallContext.Provider value={install}>{children}</InstallContext.Provider>;
}
